import { RefDataAccessor } from "@libs/api/ref-data/RefDataAccessor.ts";
import { IBhbGateway } from "@libs/gateways/bhb/bhbGateway.interface.ts";
import { Ref } from "@stores/types/ref.type.ts";

export class BhbRef implements Ref<keyof BhbRef> {
  constructor(private gateway: IBhbGateway) {}

  areasOfInterest = new RefDataAccessor(() => this.gateway.getAreaOfInterest());
}
